import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSuperAdminAuth } from './SuperAdminAuthContext.jsx';

export function RequireSuperAdmin() {
  const { status } = useSuperAdminAuth();
  const location = useLocation();

  if (status === 'loading') return null;
  if (status === 'anonymous') return <Navigate to="/super-admin/login" replace state={{ from: location }} />;
  return <Outlet />;
}
